import React, { Component } from "react";
import CharacterCard from "./components/CharacterCard";
import Navbar from "./components/Navbar/Navbar";
import Header from "./components/Header/Header";
import characters from "./character.json";
import "./App.css";

class App extends Component {
  state = {
    message: "Click an image to begin!",
    characters: characters,
    currentScore: 0,
    topScore: 0,
    unselectedCharacter: characters
  };

  shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  selectCharacter = id => {
    const findCharacters = this.state.unselectedCharacter.find(
      item => item.id === id
    );

    if (findCharacters === undefined) {
      this.setState({
        message: "You guessed incorrectly!",
        topScore:
          this.state.currentScore > this.state.topScore
            ? this.state.currentScore
            : this.state.topScore,
        currentScore: 0,
        characters: characters,
        unselectedCharacter: characters
      });
    } else {
      const newCharacters = this.state.unselectedCharacter.filter(
        item => item.id !== id
      );

      this.setState({
        message: "You guessed correctly!",
        currentScore: this.state.currentScore + 1,
        characters: characters,
        unselectedCharacter: newCharacters
      });
    }

    this.shuffleArray(characters);
  };

  render() {
    return (
      <div className="App">
        <Navbar
          message={this.state.message}
          currentScore={this.state.currentScore}
          topScore={this.state.topScore}
        />
        <Header />
        <div className="cardHolder">
          {this.state.characters.map(character => (
            <CharacterCard
              id={character.id}
              key={character.id}
              clicked={character.clicked}
              image={character.image}
              selectCharacter={this.selectCharacter}
              currentScore={this.state.curScore}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js